export const {STREAM_SERVER}= window._env_